import CssResource from "./Css";
import {ResourceType} from "./Resource";

export default class ResourceFactory {
    create(type: ResourceType, source: string) {
        switch (type) {
            case ResourceType.Css:
                return new CssResource(ResourceType.Css, source);

            default:
                throw new Error("Unsupported resource type");
        }
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/resources/Factory.ts
 **/